"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForSchemeChange = exports.setColorScheme = exports.getColorScheme = exports.THEME_DARK = exports.THEME_LIGHT = exports.THEME_SYSTEM = exports.THEME_DEFAULT = exports.THEME_CHANGE_EVENT = exports.THEME_DATA_ATTRIBUTE = void 0;
const COOKIE_NAME = 'uikit-color-scheme';
exports.THEME_DATA_ATTRIBUTE = 'data-theme';
exports.THEME_CHANGE_EVENT = 'themechange';
const PATH = '/';
const DOMAIN = '.rio.cloud';
const EXPIRATION_DATE = 'Thu, 18 Dec 2030 12:00:00 UTC';
exports.THEME_DEFAULT = 'default';
exports.THEME_SYSTEM = 'system';
exports.THEME_LIGHT = 'light';
exports.THEME_DARK = 'dark';
const getColorScheme = () => readColorSchemeFromCookie();
exports.getColorScheme = getColorScheme;
const setColorScheme = scheme => writeColorSchemeToCookie(scheme);
exports.setColorScheme = setColorScheme;
const listenForSchemeChange = () => listenForCookieChange();
exports.listenForSchemeChange = listenForSchemeChange;
const readColorSchemeFromCookie = () => {
    const decodedCookie = decodeURIComponent(document.cookie);
    // console.debug(decodedCookie);
    const [uikitCname] = decodedCookie.split(';').filter(entry => entry.includes(COOKIE_NAME));
    if (!uikitCname) {
        return;
    }
    const [, colorScheme] = uikitCname.split('=');
    console.debug(`readColorSchemeFromCookie: ${colorScheme}`);
    if (!colorScheme) {
        return;
    }
    const html = document.documentElement;
    if (colorScheme === exports.THEME_DEFAULT) {
        html.removeAttribute(exports.THEME_DATA_ATTRIBUTE);
        return colorScheme;
    }
    if (colorScheme === exports.THEME_SYSTEM) {
        if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
            html.setAttribute(exports.THEME_DATA_ATTRIBUTE, exports.THEME_DARK);
        }
        else {
            html.setAttribute(exports.THEME_DATA_ATTRIBUTE, exports.THEME_LIGHT);
        }
        return colorScheme;
    }
    if (colorScheme === exports.THEME_LIGHT || colorScheme === exports.THEME_DARK) {
        html.setAttribute(exports.THEME_DATA_ATTRIBUTE, colorScheme);
        return colorScheme;
    }
};
// This should be done by a RIO service like User Profile SPA using a theme switcher component from the uikit
// where this function is referenced
const writeColorSchemeToCookie = scheme => {
    const isDevEnv = (window === null || window === void 0 ? void 0 : window.location.host.startsWith('localhost')) || (window === null || window === void 0 ? void 0 : window.location.host.startsWith('127.0.0.1'));
    const newCookieValues = encodeURIComponent(scheme);
    const cookie = `${COOKIE_NAME}=${newCookieValues};domain=${isDevEnv ? 'localhost' : DOMAIN};expires=${EXPIRATION_DATE};path=${PATH}`;
    console.log(`writeColorSchemeToCookie: ${cookie}`);
    document.cookie = cookie;
};
const listenForCookieChange = () => {
    const eventHandler = event => {
        if (event.data === exports.THEME_CHANGE_EVENT) {
            readColorSchemeFromCookie();
            // Re-send the event to all iframes that might not be notified yet
            [...document === null || document === void 0 ? void 0 : document.getElementsByTagName('iframe')].map(frame => { var _a; return (_a = frame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(exports.THEME_CHANGE_EVENT, '*'); });
        }
    };
    window === null || window === void 0 ? void 0 : window.addEventListener('message', eventHandler, false);
};
